<section class="section-parametre" [ngBusy]="{
    busy: busyGet,
    message: 'Veuillez patienter ...',
    backdrop: false
  }">
      <div class="">
          <div class="row clearfix">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="card">
                      <div class="body table-responsive">
                          <table class="table table-stripped table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th colspan="12">
                                          <div class="row mt-1">
  
                                              <div class="col-md-3 select-container">
                                                  <!-- {{user.is_admin_group}} -->
                                                  <ng-select [disabled]="true"
                                                      [(ngModel)]="filiale_id" placeholder="Choisissez filiale "
                                                      name="filiale_id" id="filiale_id" [multiple]="false"
                                                      [closeOnSelect]="true" (change)="load_filiale_data()">
                                                      <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{
                                                          item?.libelle }}
                                                      </ng-option>
                                                  </ng-select>
                                              </div>

                                              
  
                                              <div class="col-md-3">
                                                  <input [(ngModel)]="searchKey"
                                                      class="form-control custom-input pull-left"
                                                      placeholder="Rechercher ..."
                                                      (keyup)="currentPage = 0; getItems()" />
                                              </div>
  
                                              <!-- <div class="col-md-7">
                                                  <button type="button" class="btn btn-md custom_btn_primary pull-right"
                                                      (click)="openAddItemModal()">
                                                      <i class="fa fa-plus"></i>&nbsp; Ajouter
                                                  </button>
                                              </div> -->
                                          </div>
                                      </th>
                                  </tr>
                                  <tr class="custom-table-head">
                                      <th>
                                          <a style="cursor: pointer" (click)="currentPage = 0; getItems()"
                                              title="Actualiser">
                                              <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                                      </th>
                                      <!-- <th>Code</th> -->
                                      <!-- <th>Code</th> -->
                                      <th>Codif.</th>
                                      <th>Libellé</th>
                                      <!-- <th>Agence</th> -->
                                      <th>Garant</th>
                                      <th>Catégorie</th>
                                      <th>Mode tarification</th>
                                      <th>Réseau de soin</th>
                                      <th>Type remboursement</th>
                                      <!-- <th>Créé le</th> -->
                                      <!-- <th>Statut</th> -->
                                      <!-- <th>Crée par</th> -->
                                      <!-- <th>Modifié le</th>
                  <th>Modifié par</th> -->
                                      <th class="txt-align-center">Actions</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let item of items; let indice = index">
                                      <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) *
                                          this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                                      <!-- <td>{{ item?.code}}</td> -->
                                      <!-- <td>{{ item?.code}}</td> -->
                                      <td>{{ item?.codification}}</td>
                                      <td>{{ item?.libelle}}</td>
                                      <!-- <td>{{ item?.agence_libelle}}</td> -->
                                      <td>{{ item?.garant_libelle}}</td>
                                      <td>{{ item?.categorie_police_libelle}}</td>
                                      <td>{{ item?.mode_tarification_libelle}}</td>
                                      <td style="text-decoration: underline;color: blue;cursor: pointer;" (click)="openModalPrestataireReseau(item)">{{ item?.reseau_de_soin_libelle}}</td>
                                      <td>{{ item?.type_remboursement_libelle}}</td>
                                      <!-- <td>{{ item?.created_at | dateTimeFormat}}</td> -->
                                      <!-- <td>{{ item?.statut_police_libelle}}</td> -->
                                      <!-- <td>{{ item?.created_by_login}}</td> -->
                                      <!-- <td>{{ item?.updated_at | dateTimeFormat}}</td>
                  <td>{{ item?.updated_by_login}}</td> -->
                                      <!-- <td>
                                          <div class="custom-td-action">
                                              <a title="Modifier" (click)="openAddItemModal(item)"
                                                  class="custom-btn-update">
                                                  <i class="fa fa-edit"></i></a>
                                              <a title="Supprimer" (click)="confirmDelete(item)"
                                                  class="custom-btn-delete">
                                                  <i class="fa fa-trash"></i></a>
                                          </div>
                                      </td> -->
                                  </tr>
                              </tbody>
  
                              <tfoot>
                                  <tr *ngIf="items && items.length > 0">
                                      <td colspan="12">
                                          <div class="row pagination-part">
                                              <div class="col-md-9" style="text-align: center">
                                                  <pagination [maxSize]="5" [boundaryLinks]="true"
                                                      [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                                                      [(ngModel)]="currentPage" class="pagination-sm"
                                                      previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                                                      lastText="&raquo;" (pageChanged)="pageChanged($event)">
                                                  </pagination>
                                              </div>
  
                                              <div class="col-md-3">
                                                  <div class="paginator-per-page">
                                                      <app-element-by-page-paginator (paginationChange)="
                              changePaginationSize($event)
                            " [defaultItemPerPage]="itemsPerPage">
                                                      </app-element-by-page-paginator>
  
                                                      <span class="span_total_entree pull-right">Total : {{ totalItems
                                                          }}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                  </tr>
  
                                  <tr *ngIf="!items || items.length == 0">
                                      <td colspan="12">
                                          <div class="col-md-12 txt-align-center">
                                              Aucune donnée disponible
                                          </div>
                                      </td>
                                  </tr>
                              </tfoot>
                          </table>
                      </div>
                  </div>
  
  
  
              </div>
          </div>
      </div>
  </section>